if (!customElements.get('nova-drawer-controller')) {
	class NovaDrawerController extends HTMLElement {
		constructor() {
			super();
			this.observer = null;
			this.observerOptions = {
				attributes: true,
				attributesFilter: ['open']
			}
			this.closeOtherMenuDrawersBool = false;
		}

		get menuDrawers() {
			return [...this.querySelectorAll('nova-drawer')];
		}

		observeDrawersOpenAttribute() {
			this.observer = new MutationObserver(this.onDrawerOpenAttributeChange.bind(this));

			this.menuDrawers.forEach(drawer => this.observer.observe(drawer, this.observerOptions));
		}

		drawerIsOpen(drawer) {
			return drawer.hasAttribute('open');
		}

		onDrawerOpenAttributeChange(mutationsList) {
			mutationsList.forEach(({ attributeName, target }) => {
				if (attributeName === 'open') {
					const drawer = target;
					if (this.drawerIsOpen(drawer)) {
						this.closeOtherMenuDrawers(drawer);
					}
				}
			});
		}

		closeOtherMenuDrawers(currentDrawer) {
			this.menuDrawers.filter(drawer => {
				const childDrawer = [...drawer.querySelectorAll('nova-drawer')];
				const childDrawerIsCurrentDrawer = childDrawer.length && childDrawer.some(drawer => drawer === currentDrawer);

				if (drawer !== currentDrawer && !childDrawerIsCurrentDrawer) return true;

				return false;
			}).forEach(drawer => drawer.removeAttribute('open'));
		}

		connectedCallback() {
			this.observeDrawersOpenAttribute();
			this.menuDrawers.forEach(drawer => (drawer.isControlled = true));
		}
	}

	customElements.define('nova-drawer-controller', NovaDrawerController);
}